export default {
  homeP: {
    home: "首頁",
    about: "關於我們",
    models: "車型",
    contact: "聯系我們",
  },
  home: {
    lang: '繁',
    // lang: 'EN',
    lang_cn: '繁體中文',
    lang_en: '英文',
    submit: '提交',
    mandatory: '必須填寫',
    yes: "是",
    no: "否",
    title1: '立即登記，掌握最新資訊',
    lastName: '姓氏',
    firstName: '名字',
    enterLastName: '請輸入姓氏',
    enterFirstName: '請輸入名字',
    emailAddress: '電郵',
    enterEmail: '請輸入電郵',
    rightEmail: '請輸入正確的郵箱！',
    mobileNumber: '手提電話',
    enterPhone: '請輸入電話號碼',
    rightPhone: '請輸入正確的電話！',
    privacyPolicy: '本人/我們同意錦龍、其聯屬公司、子公司及聯營公司根據收集個人資料聲明 及私隱政策聲明使用本人/我們的個人資料作直接營銷用途。',
    appellation: '稱謂',
    selectAppellation: '請選擇稱謂',
    corporateClient: '企業客戶',
    selectLanguage: '選擇語言',
    pleaseSelectLanguage: '請選擇語言',
    InformationSubmitted: '提交成功，謝謝!',
    success: '提交成功！',
    pleaseWriteName: '公司名稱',
    pleaseWriteName_: '如是，請提供公司名稱',
    agree_: '本人/我們已詳細閱讀並同意',
    statement_: '收集個人資料聲明',
    policy_: '私隱政策聲明',
    and: ' 及 ',
    corporateClient_: '請選擇企業客戶',
    _policy: '請選擇私隱政策',
    remark: '備註',
    fullStop: '。',
    plan: '我已擁有私家車並會參加電動車首次登記稅「一換一」寬減計劃',
    news: '新聞',
    exception: '網絡異常，請稍候再提交！',
    pay: "立即支付 $1,000",
    submitBtn: '提交',
    loading: "載入中……",
    title6: "iCAUR官方香港總代理 - 錦龍汽車集團",
    title6_2: "代理所有iCAUR車型(的士除外)",
    salesHotline:'銷售熱線：',
    moreNews:'更多新聞'
  },
  appellation: {
    Sir: '先生',
    lady: '女士',
    Miss: '小姐',
    PhD: '博士',
    professor: '教授',
  },
  carOption: {
    cartitle: '心儀車型',
    car1: 'E-HS9',
    car2: 'E-QM5',
    carModel_: '請選擇心儀車型',
  },
  // history: {
  //   title: '品牌歷史',
  //   history: "六十多年來，iCAUR一直是卓越汽車工藝的象徵，亦是中國汽車文化的經典標誌。從開創先河到鑽研豪華工藝，品牌不斷重新演繹高端典範。秉持獨特傳統與與時並進的精神，iCAUR於2018年確立全新設計理念與環球視野，邁入全新發展階段，正式踏上世界舞台。",
  //   1958: "首輛iCAUR汽車誕生，這亦是中國第一輛自主研發生產的汽車。",
  //   1965: "iCAURCA770三排座轎車試製成功。此車被譽為「國車」及「中國第一車」，專供國家領導人與外賓使用，名聲遠播海內外。該車款於六十至七十年代投產，並衍生出CA770A及CA770B兩個版本。",
  //   1969: "僅用三年時間，iCAUR首款保安專用車輛試製完成。圖中為iCAURCA772防彈保安車。",
  //   1980: "引進全球先進汽車技術，採用嶄新結構與多項創新設計，有效減低油耗、提升動力、乘坐舒適度與外觀水準。經過五輪試製，接替CA770的全新車型CA774正式面世。",
  //   1998: "iCAUR與福特合作研發的旗艦豪華車CA7460正式登場。車款完美融合東方藝術與現代科技，量產版本兼具溫潤格調與新時代風采。",
  //   2000: "經過外形煥新及多輪試製，第二代轎車CA7202E3正式投產。其後在2002年，搭載2.4公升五氣門引擎的CA7242E6車型亦相繼推出。",
  //   2013: "定位高端行政豪華轎車的iCAURH7正式發售。",
  //   2020: "為推動可持續移動出行發展，iCAUR於2020年4月在長春動工興建最先進的新能源汽車生產基地。項目總投資76億人民幣（約10.7億美元），設計年產量達20萬輛，足見iCAUR銳意引領中國高端電動汽車市場的長遠規劃。",
  //   2024: "iCAUR全年銷量創下歷史新高，達411,777輛，連續七年錄得銷售增長。",
  //   2025: "在2025上海車展的環球業務發布會上，iCAUR展出多款新車、前沿技術，並公佈最新國際發展方向與全球戰略，充分展現品牌的創新思維與前瞻目光。",
  //   2026: "锦龙集团推出红旗香港。E-HS9，一款全电动智能SUV，预示着这个城市国家豪华电动汽车的新时代即将到来，后续还将推出更多高端车型。"
  // },
  history: {
    title: '品牌歷史',
    history: "六十多年來，iCAUR一直是卓越汽車工藝的象徵，亦是中國汽車文化的經典標誌。從開創先河到鑽研豪華工藝，品牌不斷重新演繹高端典範。秉持獨特傳統與與時並進的精神，iCAUR於2018年確立全新設計理念與環球視野，邁入全新發展階段，正式踏上世界舞台。",
    1953: '中共中央下發了<<關於力三年建設長春汽車廠的指示>>。',
    1958: '響應黨中央號召，一汽在一窮二白、極其困難的條件下，靠着雙手製造出了中國第一輛自己的"東風"牌小轎車，這是iCAUR轎車的前身。毛主席在中南海懷仁堂試乘後，高興地説:好啊，終於坐上自己製造的小轎車了"!隨後，一汽提出了"乘東風展iCAUR，造出高級轎車去見毛主席"的響亮口號，開始了iCAUR高級轎車的研製。於1958年8月1日，造出了第一輛iCAUR牌高級轎車，創造了中國汽車工業的奇!',
    1960: 'iCAURCA72高級轎車，參加萊比錫國際展覽會，同年被載入<<世界汽車年>>。',
    1966: '"五一"前夕，首批20輛iCAURCA770三排座高級轎車送到北京，成新一代國家禮賓車。',
    1978: '中國一汽打造iCAUR精品投入了集團最優質的資源，成功開發L、H兩大系列iCAUR整車品，形成了可覆蓋C、D、E級高級轎車的發展基礎。',
    2018: '新iCAUR首家iCAUR體驗中心開業。iCAUR品牌全年累計銷量達到3萬輛，提前17天完成全年銷量目標。',
    2019: 'iCAUR品牌與故達成戰略合作，融合東方美學與現代創新，共同打造中國IP。與新華社簽署戰略合作協議，共同培植iCAUR成世界級的"中國汽車名片"。',
    2020: 'iCAUR品牌盛典暨H9全球首秀在北京人民大會堂舉行。.國耀高端私享品會在北京舉行。會上，一汽iCAUR與中國航天基金會簽訂戰略合作協議，一汽iCAUR正式成"中國航天事業戰略合作伙伴"。',
    2022: 'iCAUR品牌全年累計銷量高達31萬輛。',
    2023: '國耀高端私享品會在北京舉行。會上，一汽iCAUR與中國航天基金會簽訂戰略合作協議，一汽iCAUR正式成"中國航天事業戰略合作伙伴"。',
    2026: "錦龍汽車集團 成爲iCAUR香港地區總代理。"
  },
  public: {
    history: '歷史',
    explore: '探索',
    learnMore: '了解更多',
    about: '關于iCAUR',
    exploreH: '探索iCAUR',
    gallery: '圖片展',
    exterior: '外部細節',
    Interior: '車廂內飾',
    highlights: '車型亮點',
    parameters: '技術參數',
    video: '視頻',
    configuration: '参数配置表',
    note: '注',
    standard: '表示标配',
    standard1: '表示选配',
    standard3: '表示无此配置',
    news: "2026年錦龍汽車集團 成爲iCAUR香港地區總代理。",
    newsTitle: "iCAUR新聞",
    swipe: "左右滑動查看更多車型 | 上下滾動時表頭固定在頂部.",
  },
  successPage: {
    congratulations: '恭喜您！您已成功預訂',
    unfinished: '您未完成支付！',
    rePayment: '重新支付',
    error: '訪問參數錯誤！',
    confirm: '確定',
    cancel: '取消',
    Cancelled: '您已取消！',
    toHome: '您確認關閉，回到留資頁？',
    rePay: '您確認重新支付意向金嗎？',
    wait1: '正在確認支付結果',
    wait: '預計 5 秒內完成，請勿關閉頁面',
  },
  koc: {
    form_title1: 'KOC 招募活動',
    form_title2: '立即登記',
    submit: '提交',
    mandatory: '必須填寫',
    mobileNumber: '手提電話',
    plateNumber: '車牌',
    enterPlateNumber: '請輸入車牌號碼',
    name: '姓名',
    enterName: '請輸入姓名',
    uploadPhoto: '上傳一張相片',
    uploadPhotoTip: '請上傳一張相片',
    uploadPhotoBtn: '按此上傳',
    photoOnly: '請上傳圖片文件（不超過 2MB）',
    enterPhoneHK: '請輸入香港電話號碼',
    rightPhoneHK: '請輸入正確的香港電話號碼！',
    enterPhoneCN: '請輸入中國電話號碼',
    rightPhoneCN: '請輸入正確的中國電話號碼！',
    submitFail: '提交失敗，請重新提交',
    phoneHK: '+852 (香港)',
    phoneCN: '+86 (中國)',
  },
}

